<template>
    <div class="section_12 flex-col">
      <div class="image-wrapper_8 flex-row justify-between">
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNGed7b0ffa4b151a33e18361666d1907e0.png'"
        />
        <img
          class="image_26"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNG0c87d97c656b4d11313cc0384fc90e29.png'"
        />
      </div>
      <div class="box_5 flex-row justify-between">
        <div class="group_13 flex-col justify-between">
          <div class="text-wrapper_22">
            <span class="text_60">联系方式：</span>
            <span class="text_61">13220190868</span>
          </div>
          <div class="text-wrapper_23">
            <span class="text_62">Email：</span>
            <span class="text_63">info&#64;ktangtang.com</span>
          </div>
          <div class="text-wrapper_24">
            <span class="text_64">官网地址：</span>
            <span class="text_65">https://ktangtang.com</span>
          </div>
        </div>
        <div class="image-text_12 flex-col justify-between">
          <img
            class="image_27"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNGa59de064abb235dd82d18559767c6254.png'"
          />
          <span class="text-group_14">公众号二维码</span>
        </div>
      </div>
      <div class="text-wrapper_25 flex-row">
        <span class="text_66">公司地址：</span>
        <span class="text_67">北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
      </div>
      <div class="box_6 flex-row justify-between">
        <div class="text-wrapper_26">
          <span class="text_68">公众号：</span>
          <span class="text_69">以动健康</span>
        </div>
        <div class="text-wrapper_27">
          <span class="text_70">官方微博：</span>
          <span class="text_71">&#64;以动健康</span>
        </div>
      </div>
      <span class="text_72">京ICP备19026627号</span>
    </div>

  
</template>
<script>


export default {

  data() {
    return {
      imgs: [
        'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNG0eb2ab64e6d7a192cfcba0b43c60982c.png',
        'https://web-cdn.ktangtang.com/official-website/footery/home1.png',
        'https://web-cdn.ktangtang.com/official-website/footery/home2.png',
        'https://web-cdn.ktangtang.com/official-website/footery/home3.png',
    
       ],
       imgs1: [
        'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNGf37eb04b0eaf90279303568037fb7c49.png',
        'https://web-cdn.ktangtang.com/official-website/footery/home11.png',
        'https://web-cdn.ktangtang.com/official-website/footery/home12.png',
        'https://web-cdn.ktangtang.com/official-website/footery/home13.png',
        'https://web-cdn.ktangtang.com/official-website/footery/home14.png',
    
       ],
       imgsName: ['以动物联网护心控糖功率车','以动物联网护心控糖向心功率车','以动中老年体适能一体机','主动有氧被动离心功率车'],
       imgs1Name: ['心率墙','全身有氧训练机（侧摆臂）IC7006','全⾝肌⼒训练机 IC7008','全⾝脑部肢体协调训练机 IC7009', '全⾝线性有氧健⾝⻋ IC7007'],
       currName: '以动物联网护心控糖功率车',
       currName1: '心率墙',
      loopData0: [
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNGbcfe054f744fa55a9963a88ca7a73e23.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNG50151a5ee0687b4ec426ead9ecbd38bb.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/footery/FigmaDDSSlicePNG1e25025c15e9fb3f5c6019e4e97c759a.png'
        }
      ],
      constants: {}
    };
  },
  methods: {
    toSt (){
      this.$router.push({path: '/workstation'})
    },  
    imgsChange(e){
      this.currName = this.imgsName[e]
    },
    imgs1Change(e){
      this.currName1 = this.imgs1Name[e]
    },
    arrowClick(val, bu) {
      console.log(val, bu)
      let info = ""
      if(bu === '0'){
        info = this.$refs.cardShow
      }else{
        info = this.$refs.cardShow1
      }
      
      if(val === 'next' && info !=="") {
        info.next()
      } else {
       info.prev()
      }
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />